import React from "react";

export const Switch = ({className, label, id, ...props}) => {
    return (<div className="checkbox-wrapper-14 flex justify-between my-2">
        {label && <label htmlFor={id}>{label}</label>}
        <input id={id} type="checkbox" className={`switch ${className}`} {...props}/>
    </div>)
}

